import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  selectMarketApiActionLoading,
  selectSelectedMarketApiApiKey,
  selectShowMarketApiEditorModal,
  handleHideMarketApiEditorModal,
  createMarketApiApiKeyAsync,
  updateMarketApiApiKeyAsync,
  getMarketApiApiKeysAysnc,
} from "../../../store/market-api/apiKeysSlice";
import { MarketApiApiKeySchema } from "../../../utils/validations";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { Modal, Button, Input } from "djuno-design";
import { useCallback, useEffect } from "react";

const ApiKeyEditorModal = () => {
  const isOpen = useAppSelector(selectShowMarketApiEditorModal);
  const loading = useAppSelector(selectMarketApiActionLoading);
  const apiKey = useAppSelector(selectSelectedMarketApiApiKey);
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(MarketApiApiKeySchema),
  });

  useEffect(() => {
    if (isOpen && apiKey) {
      setValue("label", apiKey.Label);
    }
  }, [isOpen, apiKey, setValue]);

  const onSubmit = (data: any) => {
    if (apiKey) {
      dispatch(
        updateMarketApiApiKeyAsync({
          id: apiKey.Id,
          formData: {
            label: data.label,
          },
        })
      ).then((action) => {
        if (action.type === "market-api/api-keys/update/fulfilled") {
          reset();
          dispatch(handleHideMarketApiEditorModal());
          dispatch(getMarketApiApiKeysAysnc());
        }
      });
    } else {
      dispatch(
        createMarketApiApiKeyAsync({
          label: data.label,
        })
      ).then((action) => {
        if (action.type === "market-api/api-keys/create/fulfilled") {
          reset();
          dispatch(handleHideMarketApiEditorModal());
          dispatch(getMarketApiApiKeysAysnc());
        }
      });
    }
  };

  const handleOnClose = useCallback(() => {
    dispatch(handleHideMarketApiEditorModal());
    reset();
  }, [dispatch, reset]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-lg"
      //   containerClassName="!items-start"
      title={apiKey ? "Update API key" : "Create new API key"}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5 flex flex-col w-full gap-5">
          <Input
            label="API key label"
            {...register("label")}
            error={errors.label?.message}
            placeholder=""
            required
          />
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            loading={loading}
            uiType="primary"
            disabled={loading}
            type="submit"
            className="w-[100px]"
          >
            {apiKey ? "Update" : "Create"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ApiKeyEditorModal;
